import request from '@/utils/request'

// 通用类型选项数据
// parentId: 按父通用类型过滤（如模组型号按厂商）
export function findCommonTypeOptions(typeSlug, subTypeSlug, parentId) {
  const params = { type_slug: typeSlug }
  if (subTypeSlug) {
    params.sub_type_slug = subTypeSlug
  }
  if (parentId) {
    params.parent_id = parentId
  }
  return request({
    url: `/common_types/options`,
    method: 'get',
    params
  })
}
